import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import { useFocusRestoreWithoutScroll } from "web_myplann/Shared/Hooks/useFocusRestoreWithoutScroll";

type Props = {
	open: boolean;
	onClose: () => void;
	title: string;
	description: string;
	primaryLabel: string;
	onPrimary: () => void;
	secondaryLabel?: string;
	onSecondary?: () => void;
	preventScrollOnClose?: boolean;
	children: ReactNode;
};

export const InspirationSheet: FC<Props> = ({
	open,
	onClose,
	title,
	description,
	primaryLabel,
	onPrimary,
	secondaryLabel,
	onSecondary,
	preventScrollOnClose,
	children,
}) => {
	const theme = useTheme();

	useFocusRestoreWithoutScroll(open && !!preventScrollOnClose);

	return (
		<MyPlannDrawer
			open={open}
			disableRestoreFocus={preventScrollOnClose}
			onClose={onClose}
			title={title}
			paperSx={{ bgcolor: theme.palette.background.paper }}
		>
			<Stack px={1.6} pt={0.4} pb={4} gap={1.2}>
				<Typography variant="body1" color={theme.palette.grey[500]}>
					{description}
				</Typography>

				{children}

				<Button variant="primary" onClick={onPrimary}>
					{primaryLabel}
				</Button>

				{secondaryLabel && onSecondary && (
					<Button variant="tertiary" onClick={onSecondary}>
						{secondaryLabel}
					</Button>
				)}
			</Stack>
		</MyPlannDrawer>
	);
};
